import { IconButton } from '@mui/material';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import CancelIcon from '@mui/icons-material/Cancel';

import { ITileCacheSeederActions, ITileCacheSeedOperation } from '../../MapComponents/TileCache/types';

import uiStyles from "../../../Lib/UI/UI.module.css";


interface DownloadListItemActionsProps {
    seederActions: ITileCacheSeederActions,
    op: ITileCacheSeedOperation;
    onRemove: (op: ITileCacheSeedOperation) => void;
    onCancel: (op: ITileCacheSeedOperation) => void;
    disabled?: boolean;
}

const DownloadListItemActions = (props: DownloadListItemActionsProps): JSX.Element => {
    return (
        <>
        {props.seederActions.canRemove(props.op) &&
            <IconButton edge="end" aria-label="Remove" title="Remove" className={uiStyles.list_action} onClick={() => props.onRemove(props.op)} disabled={props.disabled}>
                <CleaningServicesIcon fontSize='large' />
            </IconButton>
        }

        {props.seederActions.canCancel(props.op) &&
            <IconButton edge="end" aria-label="Cancel" title="Cancel" className={uiStyles.list_action} onClick={() => props.onCancel(props.op)} disabled={props.disabled}>
                <CancelIcon fontSize='large' />
            </IconButton>
        }
        </>
    );
};

export default DownloadListItemActions;